import axios from "axios";

export function getOrders() {
    return axios.get('order/orders');
}

export function getOrder(id) {
    return axios.get(`order/get-order/${id}`);
}
